<template>
  <section class="detail-section lista-recolhivel">
    <button
      type="button"
      class="lista-cabecalho"
      :aria-expanded="aberta ? 'true' : 'false'"
      @click="aberta = !aberta"
    >
      <v-icon size="18" class="lista-chevron" :class="{ 'is-open': aberta }">
        mdi-chevron-right
      </v-icon>
      <span class="lista-titulo">{{ titulo }}</span>
      <span class="lista-contagem">{{ total }}</span>
    </button>
    <div v-show="aberta" class="lista-corpo">
      <slot />
    </div>
  </section>
</template>

<script>
// Lista que COMECA RECOLHIDA: o titulo e a contagem ficam visiveis e o conteudo abre ao clicar.
export default {
  name: "ListaRecolhivel",
  props: {
    titulo: { type: String, required: true },
    total: { type: [Number, String], default: 0 },
    aberta0: { type: Boolean, default: false },
  },
  data() {
    return { aberta: this.aberta0 };
  },
};
</script>

<style scoped lang="scss">
.lista-recolhivel {
  padding-top: 0;
  padding-bottom: 0;
}
.lista-cabecalho {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 14px 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;

  &:hover .lista-titulo {
    text-decoration: underline;
  }
}
.lista-chevron {
  transition: transform 0.15s ease;

  &.is-open {
    transform: rotate(90deg);
  }
}
.lista-titulo {
  font-weight: 600;
  font-size: 0.95rem;
}
.lista-contagem {
  margin-left: auto;
  padding: 1px 12px;
  border-radius: 12px;
  background: #eef2f6;
  color: #55606c;
  font-size: 0.82rem;
  font-weight: 600;
}
.lista-corpo {
  padding-bottom: 16px;
}
</style>
